import { Command, CommandEnum } from "./CommandModule";
import { Events } from "../events";
import { eventsManager } from "../managers/EventsManager";
import { CeilingBox, EntityFactory, Joinery, SceneConstants, TechnicalElement, math } from "../SavaneJS";

export class EditJoineryCommand extends Command {
    private _modifiedJoinery: Joinery;
    private _currentJoinery: Joinery;
    
    constructor(currentJoinery: Joinery) {
        super();
        // Clone current joinery so it copies the temporary fields into the cloned joinery entity
        this._modifiedJoinery = EntityFactory.getInstance().cloneEntity(currentJoinery, false) as Joinery;
        //var position = this._modifiedJoinery.position;
        this._modifiedJoinery.wall = currentJoinery.wall;
        //this._modifiedJoinery.position = position;
        // End the joinery temporary so it drops the temporary data
        currentJoinery.endTemporary();
        // Save the current joinery for future data exchange
        this._currentJoinery = currentJoinery;
    }

    // Command name returned from a global enum
    name(): string {
        return CommandEnum.EditJoineryCommand;
    }

    execDatas(): any{
        return {
            id: this._currentJoinery.id,
            type: this._currentJoinery.entityType,
            entity: this._currentJoinery,
        };
    }

    // Undo the current command
    undo() {
        // Execute the current command, the savedJoinery structure keeps the changes back and forth
        this.execute();
    }

    // Execute current command (redo)
    execute() {
        // If the joinery is on a wall remove it from the wall
        this._currentJoinery.wall.deleteJoinery(this._currentJoinery.id);
        eventsManager.instance.dispatch(Events.REMOVE_GRAPHICAL_ENTITY, {
            entity: this._currentJoinery
        });

        let swap = this._currentJoinery;
        this._currentJoinery = this._modifiedJoinery;
        this._modifiedJoinery = swap;

        // Parse all children and reassign rolling shutters position to joinery orientation to the new joinery
        for (let j = 0; j < this._currentJoinery.children.length; j++) {
            let joinChild = this._currentJoinery.children[j];

            if (joinChild.isTechnicalElementEntity() && (joinChild as TechnicalElement).objectId === SceneConstants.TechnicalElementType.ceilingBox && (joinChild as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                (joinChild as CeilingBox).length = this._currentJoinery.length;
                let positionChild = math.vec3.create();

                if (this._currentJoinery.orientation) {
                    math.vec3.set(positionChild, 0, -this._currentJoinery.wall.thickness / 2, this._currentJoinery.height + this._currentJoinery.floorHeight);
                } else {
                    math.vec3.set(positionChild, 0, this._currentJoinery.wall.thickness / 2, this._currentJoinery.height + this._currentJoinery.floorHeight);
                }
                if (this._currentJoinery.transom) {
                    positionChild[2] = this._currentJoinery.transomHeight;
                }
                joinChild.transform.localPosition = positionChild;
            }
        }

        // Place the joinery back on the final wall
        this._currentJoinery.wall.addJoinery(this._currentJoinery);
        eventsManager.instance.dispatch(Events.ADD_GRAPHICAL_ENTITY, {
            entity: this._currentJoinery
        });

        super.execute();

        // Select object at the end
        eventsManager.instance.dispatch(Events.CHANGE_EDITOR_SELECTION, {
            selection: [this._currentJoinery],
            keepSelected: false,
            showTulip: false,
        });
    }
}
